import React from 'react';

export type Refetch = (variables?: any) => Promise<any>;

export const RefetchContext = React.createContext<Refetch>(async () => {});
